import React from 'react'
import { ReactComponent as SuccessCheck } from '../../../images/icons/success_check_icon.svg'
import { Button } from '@demandlocal/components'
import { useNavigate } from 'react-router'

type Props = {
  campaignDetails?: Record<string, any>
}

const AddNewCampaignSuccess = ({ campaignDetails }: Props) => {
  const navigate = useNavigate()

  return (
    <div className={'flex flex-col items-center m-auto'}>
      <div className={'space-y-10 flex flex-col items-center'}>
        <SuccessCheck />
        <div className={'space-y-3 flex flex-col items-center'}>
          <span className={'text-3xl font-bold text-primary-xiketic'}>
            Nice! Campaign successfully created!
          </span>
          <span className={'text-base text-web-gray'}>
            Please allow 24 hours for confirmation
          </span>
        </div>
        <div className={'w-full px-10 space-y-3'}></div>
        <div className={'flex flex-col items-center gap-3'}>
          <Button
            variant={'secondary'}
            onClick={(e) => {
              e.preventDefault()
              navigate('..')
            }}>
            Close this window
          </Button>
        </div>
      </div>
    </div>
  )
}

export default AddNewCampaignSuccess
